/**
 * @generated SignedSource<<afcf07e4db143933647ae0fd2b7d272a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DirectoryAgentPageQuery$variables = {
  agentSlug: string;
};
export type DirectoryAgentPageQuery$data = {
  readonly landlordDirectoryAgent: {
    readonly " $fragmentSpreads": FragmentRefs<"DirectoryAgentPage_agent" | "DirectoryAgentSeoHead_agent" | "DirectoryAgentV2Page_agent">;
  } | null | undefined;
};
export type DirectoryAgentPageQuery = {
  response: DirectoryAgentPageQuery$data;
  variables: DirectoryAgentPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "agentSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openedYear",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "services",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redressScheme",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feesIncludeVat",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountPence",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percent",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceUrls",
  "storageKey": null
},
v12 = [
  (v9/*:: as any*/),
  (v10/*:: as any*/),
  (v11/*:: as any*/)
],
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sampleSize",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minimumPercentIncVat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "medianPercentIncVat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "maximumPercentIncVat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentsIncVat",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DirectoryAgentPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordDirectoryAgent",
        "kind": "LinkedField",
        "name": "landlordDirectoryAgent",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryAgentPage_agent"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryAgentSeoHead_agent"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryAgentV2Page_agent"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DirectoryAgentPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordDirectoryAgent",
        "kind": "LinkedField",
        "name": "landlordDirectoryAgent",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "address",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "website",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "headOfLettingsName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryPortalListing",
            "kind": "LinkedField",
            "name": "portalListings",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "listingCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleMapsUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleRating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleReviewCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trustpilotUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trustpilotRating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trustpilotReviewCount",
            "storageKey": null
          },
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasClientMoneyProtection",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enrichedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryAreaReference",
            "kind": "LinkedField",
            "name": "areas",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "strengths",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "considerations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryAgentSources",
            "kind": "LinkedField",
            "name": "sources",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trustpilot",
                "storageKey": null
              },
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMoneyProtection",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logo",
                "storageKey": null
              },
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headOfLettings",
                "storageKey": null
              },
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryAgentFees",
            "kind": "LinkedField",
            "name": "fees",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "management",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "rentCollection",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "tenantFind",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "letOnly",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "renewal",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "inventory",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "managementWithTenantInPlace",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "rentCollectionWithTenantInPlace",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentOtherFee",
                "kind": "LinkedField",
                "name": "otherFees",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/)
                ],
                "storageKey": null
              },
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFromFeeRun",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "postcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryArea",
            "kind": "LinkedField",
            "name": "primaryArea",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAreaStats",
                "kind": "LinkedField",
                "name": "stats",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDirectoryAreaPercentFeeStats",
                    "kind": "LinkedField",
                    "name": "management",
                    "plural": false,
                    "selections": (v13/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDirectoryAreaPercentFeeStats",
                    "kind": "LinkedField",
                    "name": "rentCollection",
                    "plural": false,
                    "selections": (v13/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e4027c8120784bb409be75b9a1077334",
    "id": null,
    "metadata": {},
    "name": "DirectoryAgentPageQuery",
    "operationKind": "query",
    "text": "query DirectoryAgentPageQuery(\n  $agentSlug: String!\n) {\n  landlordDirectoryAgent(slug: $agentSlug) {\n    ...DirectoryAgentPage_agent\n    ...DirectoryAgentSeoHead_agent\n    ...DirectoryAgentV2Page_agent\n    id\n  }\n}\n\nfragment DirectoryAgentCost_agent on LandlordDirectoryAgent {\n  name\n  fees {\n    feesIncludeVat\n    management {\n      percent\n      amountPence\n    }\n    rentCollection {\n      percent\n      amountPence\n    }\n    tenantFind {\n      percent\n      amountPence\n    }\n    letOnly {\n      percent\n      amountPence\n    }\n    renewal {\n      percent\n      amountPence\n    }\n    inventory {\n      percent\n      amountPence\n    }\n    managementWithTenantInPlace {\n      percent\n      amountPence\n    }\n    rentCollectionWithTenantInPlace {\n      percent\n      amountPence\n    }\n    otherFees {\n      label\n      percent\n      amountPence\n    }\n  }\n  primaryArea @featureFlag(gate: \"directory_branch_page_v2\") {\n    name\n    slug\n    stats {\n      management {\n        sampleSize\n        minimumPercentIncVat\n        medianPercentIncVat\n        maximumPercentIncVat\n        percentsIncVat\n      }\n      rentCollection {\n        sampleSize\n        minimumPercentIncVat\n        medianPercentIncVat\n        maximumPercentIncVat\n        percentsIncVat\n      }\n    }\n    id\n  }\n}\n\nfragment DirectoryAgentFeeTable_agent on LandlordDirectoryAgent {\n  name\n  fees {\n    management {\n      amountPence\n      percent\n      sourceUrls\n    }\n    rentCollection {\n      amountPence\n      percent\n      sourceUrls\n    }\n    tenantFind {\n      amountPence\n      percent\n      sourceUrls\n    }\n    letOnly {\n      amountPence\n      percent\n      sourceUrls\n    }\n    renewal {\n      amountPence\n      percent\n      sourceUrls\n    }\n    inventory {\n      amountPence\n      percent\n      sourceUrls\n    }\n    managementWithTenantInPlace {\n      amountPence\n      percent\n      sourceUrls\n    }\n    rentCollectionWithTenantInPlace {\n      amountPence\n      percent\n      sourceUrls\n    }\n    otherFees {\n      label\n      amountPence\n      percent\n      sourceUrls\n    }\n    feesIncludeVat\n  }\n  sources {\n    feesIncludeVat\n  }\n}\n\nfragment DirectoryAgentHero_agent on LandlordDirectoryAgent {\n  name\n  slug\n  logoUrl\n  postcode\n  openedYear\n  services\n  googleRating\n  googleReviewCount\n  enrichedAt\n  areas {\n    slug\n  }\n  portalListings {\n    portal\n    listingCount\n  }\n  fees {\n    management {\n      percent\n      amountPence\n    }\n    feesIncludeVat\n  }\n}\n\nfragment DirectoryAgentPage_agent on LandlordDirectoryAgent {\n  id\n  slug\n  name\n  address\n  phone\n  email\n  website\n  companyNumber\n  logoUrl\n  openedYear\n  headOfLettingsName\n  portalListings {\n    portal\n    listingCount\n    sourceUrl\n  }\n  googleMapsUrl\n  googleRating\n  googleReviewCount\n  trustpilotUrl\n  trustpilotRating\n  trustpilotReviewCount\n  services\n  redressScheme\n  hasClientMoneyProtection\n  enrichedAt\n  areas {\n    slug\n  }\n  strengths\n  considerations\n  sources {\n    trustpilot\n    services\n    redressScheme\n    clientMoneyProtection\n    logo\n    openedYear\n    headOfLettings\n  }\n  ...DirectoryFeeBlock_agent\n}\n\nfragment DirectoryAgentSeoHead_agent on LandlordDirectoryAgent {\n  slug\n  name\n  postcode\n  address\n  phone\n  website\n  googleMapsUrl\n  areas {\n    slug\n  }\n}\n\nfragment DirectoryAgentV2Page_agent on LandlordDirectoryAgent {\n  id\n  slug\n  name\n  address\n  phone\n  email\n  website\n  companyNumber\n  openedYear\n  headOfLettingsName\n  portalListings {\n    portal\n    listingCount\n    sourceUrl\n  }\n  googleMapsUrl\n  googleRating\n  googleReviewCount\n  trustpilotUrl\n  trustpilotRating\n  trustpilotReviewCount\n  services\n  redressScheme\n  hasClientMoneyProtection\n  enrichedAt\n  strengths\n  considerations\n  sources {\n    trustpilot\n    services\n    redressScheme\n    clientMoneyProtection\n    openedYear\n    headOfLettings\n  }\n  ...DirectoryAgentHero_agent\n  ...DirectoryAgentCost_agent\n  ...DirectoryAgentFeeTable_agent\n  ...DirectoryAgentSeoHead_agent\n}\n\nfragment DirectoryFeeBlock_agent on LandlordDirectoryAgent {\n  id\n  name\n  slug\n  fees {\n    management {\n      amountPence\n      percent\n      sourceUrls\n    }\n    rentCollection {\n      amountPence\n      percent\n      sourceUrls\n    }\n    tenantFind {\n      amountPence\n      percent\n      sourceUrls\n    }\n    letOnly {\n      amountPence\n      percent\n      sourceUrls\n    }\n    renewal {\n      amountPence\n      percent\n      sourceUrls\n    }\n    inventory {\n      amountPence\n      percent\n      sourceUrls\n    }\n    managementWithTenantInPlace {\n      amountPence\n      percent\n      sourceUrls\n    }\n    rentCollectionWithTenantInPlace {\n      amountPence\n      percent\n      sourceUrls\n    }\n    otherFees {\n      label\n      amountPence\n      percent\n      sourceUrls\n    }\n    feesIncludeVat\n    isFromFeeRun\n  }\n  sources {\n    feesIncludeVat\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a621817d4cf9b5a5c3154c1a671b73d";

export default node;
